import React, { useEffect, useRef, useState } from "react";

export default function Skills() {
  const [isInView, setIsInView] = useState(false);
  const skillsRef = useRef<HTMLDivElement>(null);

  const [skills, setSkills] = useState("programming")

  const skills_programming = [
    { name: "Python", level: 5 },
    { name: "R", level: 5 },
    { name: "JavaScript", level: 4.5 },
    { name: "TypeScript", level: 5 },
    { name: "SQL", level: 5 },
    { name: "MATLAB", level: 3.8 },
    { name: "Java", level: 2 },
    { name: "C++", level: 2.5 },
    { name: "C", level: 2 },
  ];

  const skills_web = [
    { name: "HTML", level: 5 },
    { name: "CSS", level: 4 },
    { name: "Flask", level: 4.7 },
    { name: "ReactJS", level: 5 },
    { name: "NodeJS", level: 4.5 },
    { name: "ExpressJS", level: 4.5 },
    { name: "RESTful API", level: 4 },
    { name: "Axios", level: 4 },
    { name: "Bootstrap", level: 4.5 },
  ]

  const skills_ui = [
    { name: "Streamlit", level: 4},
    { name: "PyQt", level: 4},
  ]

  const skills_database = [
    { name: "MongoDB", level: 4.5 },
    { name: "NoSQL", level: 4.5 },
    { name: "PostgreSQL", level: 4.2 },
    { name: "SQLite", level: 4.8 },
    { name: "MySQL", level: 4.2},
  ]

  const skills_visualization = [
    { name: "Tableau", level: 4 },
    { name: "Matplotlib", level: 5 },
    { name: "Seaborn", level: 5 },

  ]

  const skills_control = [
    { name: "Git", level: 5 },
    { name: "GitHub", level: 5 },

  ]
  const skills_libraries = [
    { name: "Tensorflow", level: 4.5 },
    { name: "Scikit-Learn", level: 4.5 },
    { name: "Keras", level: 4 },
    { name: "OpenCV", level: 4.8 },
    { name: "spaCy", level: 3 },
    { name: "PySpark", level: 2.5 },
    { name: "Meta-LLaMA-3-70B", level: 3.5 },

  ]

  const skills_cloud = [
    { name: "Google Cloud", level: 4 },
    { name: "AWS", level: 2.5 },
    { name: "Google Colab", level: 5 },
    { name: "Jupyter Notebooks", level: 2.5 },
  ]

  const skills_os = [
    { name: "Windows", level: 3 },
    { name: "Linux", level: 3 },
  ]


  const skills_language = [
    { name: "Arabic", level: 5 },
    { name: "French", level: 5 },
    { name: "English", level: 5 },
    { name: "Spanish", level: 2.5 },
  ]

 

  const skillsMapping: Record<string, { name: string; level: number }[]> = {

    programming: skills_programming,
    web: skills_web,
    database: skills_database,
    visualization: skills_visualization,
    libraries: skills_libraries,
    cloud: skills_cloud,
    ui: skills_ui,
    control: skills_control,
    os: skills_os,
    languages: skills_language,
  };
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsInView(entry.isIntersecting);
      },
      {
        threshold: 0.3, 
      }
    );

    if (skillsRef.current) {
      observer.observe(skillsRef.current);
    }

    return () => {
      if (skillsRef.current) {
        observer.unobserve(skillsRef.current);
      }
    };
  }, []);

  return (
    <div id="skills-section" ref={skillsRef} >
      <h2 className="ms-3">Skills & Knowledge</h2>
      <hr />

      <div className="skills">
        <div className="skills-buttons ms-5 mb-3">
            <button className={`btn mb-1 ${skills ==="programming" ? "btn-light" : "btn-info"}`}onClick={()=>setSkills("programming")}>Programming Languages</button> <br />
            <button className={`btn mb-1 ${skills ==="web" ? "btn-light" : "btn-info"}`} onClick={()=>setSkills("web")}>Web Development</button><br />
            <button className={`btn mb-1 ${skills ==="database" ? "btn-light" : "btn-info"}`} onClick={()=>setSkills("database")}>Database</button><br />
            <button className={`btn mb-1 ${skills ==="visualization" ? "btn-light" : "btn-info"}`} onClick={()=>setSkills("visualization")}>Data Visualization</button><br />
            <button className={`btn mb-1 ${skills ==="libraries" ? "btn-light" : "btn-info"}`}onClick={()=>setSkills("libraries")}>Machine Learning</button><br />
            <button className={`btn mb-1 ${skills ==="cloud" ? "btn-light" : "btn-info"}`}onClick={()=>setSkills("cloud")}>Cloud Platforms & Tools</button><br />
            <button className={`btn mb-1 ${skills ==="ui" ? "btn-light" : "btn-info"}`} onClick={()=>setSkills("ui")}>Data Science UI/UX</button><br />
            <button className={`btn mb-1 ${skills ==="control" ? "btn-light" : "btn-info"}`} onClick={()=>setSkills("control")}>Version Control</button><br />
            <button className={`btn mb-1 ${skills ==="os" ? "btn-light" : "btn-info"}`}  onClick={()=>setSkills("os")}>Operating Systems</button><br />
            <button className={`btn mb-1 ${skills ==="languages" ? "btn-light" : "btn-info"}`}onClick={()=>setSkills("languages")}>Languages</button><br />
        </div>


        <div style={{width:"50%"}} className="me-5 mb-3">
            {skillsMapping[skills]?.map((skill, index)=> (
                    <div key={index} className="mb-3">
                        <label>{skill.name}</label>
                        <div className="progress" style={{ height: "30px"}}>
                        <div
                            className={`progress-after ${isInView ? "fill-progress" : ""}`}
                            role="progressbar"
                            style={{
                            width: isInView ? `${(skill.level / 5) * 100}%` : "0%",
                            transition: "width 1s ease-in-out",
                            }}
                            aria-valuenow={skill.level}
                            aria-valuemin={0}
                            aria-valuemax={5}
                        >
 
                        </div>
                        </div>
                    </div>
                    ))} 
        </div>

      </div>
      

    </div>
  );
}
